import React from "react";
import "../App.css";

export default function Terms() {
  return (
    <>
      <section className="privacy-hero">
        <div className="container">
          <h1>
            TERMS <span>OF USE</span>
          </h1>

          <p className="privacy-company">
            Selenean Technologies Private Limited
          </p>

          <div className="privacy-meta">
            <span>Effective date: 13 August 2026</span>
            <span className="privacy-meta-divider">|</span>
            <span>Last updated: 13 August 2026</span>
          </div>
        </div>
      </section>

      <section className="privacy-page">
        <div className="container">
          <p className="privacy-intro">
            These Terms of Use ("Terms") are a binding legal agreement between
            you and Selenean Technologies ("Selenean", "Company", "we", "us" or
            "our"), a company incorporated under the laws of India having its
            registered office at Nandi Infotech, KIADB Plot No. 8, 1st Cross,
            Sadaramangala Road, Mahadevapura Post Bengaluru - 560048 (CIN:
            U26100KA2024PTC194103). These Terms govern your access to and use of
            the website located at https://www.seleneanteh.com/, and all
            information, content and downloadable resources made available on it
            (collectively, the "Website"). The Website is an informational
            website only: it does not offer any product, service, download,
            account registration or online payment facility, and no service is
            provided to you through it. Please read these Terms carefully
            together with our Privacy Policy and Cookie Policy before using the
            Website.
          </p>

          <article className="privacy-body">
            <section id="definitions" className="privacy-section">
              <h2>
                <span className="privacy-num">1.</span>DEFINITIONS AND
                INTERPRETATION
              </h2>

              <p>1.1. In these Terms, unless the context otherwise requires:</p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>"Content"</strong> means any text, data, images,
                    graphics, descriptions of Selenean’s products or technology,
                    or other material made available on the Website;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>"Personal Data"</strong> has the meaning given to it
                    in our Privacy Policy;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>"User Content"</strong> has the meaning given in
                    Clause 5 (Intellectual Property);
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>
                    <strong>"you"</strong> or <strong>"User"</strong> means the
                    individual or entity accessing or using the Website, and,
                    where you act on behalf of an organisation, includes that
                    organisation.
                  </span>
                </li>
              </ul>

              <p>
                1.2. Headings are for convenience only and do not affect
                interpretation. Words importing the singular include the plural
                and vice versa.
              </p>
            </section>

            <section id="acceptance" className="privacy-section">
              <h2>
                <span className="privacy-num">2.</span>ACCEPTANCE OF TERMS
              </h2>

              <p>
                2.1. By accessing or using the Website, you agree to be bound by
                these Terms and by our Privacy Policy and Cookie Policy, each of
                which is incorporated into these Terms by reference. If you are
                using the Website on behalf of an organisation, you represent and
                warrant that you have authority to bind that organisation, and
                "you" then refers to that organisation.
              </p>

              <p>
                2.2. If you do not agree to these Terms, you must not access or
                use the Website. We may restrict or suspend access to the Website
                for any person at our discretion, subject to applicable law.
              </p>
            </section>

            <section id="eligibility" className="privacy-section">
              <h2>
                <span className="privacy-num">3.</span>ELIGIBILITY
              </h2>

              <p>
                3.1. You must be at least 18 years of age, or the age of legal
                majority in your jurisdiction if higher, and capable of entering
                into a binding contract, to use the Website. The Website is not
                directed at children, and children's data is handled solely in
                accordance with our Privacy Policy.
              </p>

              <p>
                3.2. The Website does not require, and does not offer, account
                registration. Where you submit information to us through a
                contact, inquiry or similar form on the Website, you agree to
                provide accurate, current and complete information.
              </p>
            </section>

            <section id="use" className="privacy-section">
              <h2>
                <span className="privacy-num">4.</span>USE OF THE WEBSITE
              </h2>

              <p>
                4.1. Subject to your compliance with these Terms, Selenean grants
                you a limited, non-exclusive, non-transferable, revocable licence
                to access and view the Website solely for your own informational
                purposes. You agree to use the Website only for lawful purposes
                and in accordance with all applicable law.
              </p>

              <p>4.2. You shall not, and shall not permit any third party to:</p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    reverse engineer, decompile, disassemble, or otherwise
                    attempt to derive source code or other underlying
                    representations of any Content or technology underlying the
                    Website;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    copy, modify, adapt, translate or create derivative works
                    based on the Website or any Content, except as expressly
                    permitted by law;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    transmit malware, viruses or other harmful or disruptive code
                    through the Website;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>
                    interfere with, disrupt, or place undue burden on our
                    servers, networks or infrastructure;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(e)</span>
                  <span>
                    use automated systems, bots or scrapers to access the
                    Website without our prior written consent;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(f)</span>
                  <span>
                    attempt to gain unauthorised access to any part of the
                    Website or connected systems;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(g)</span>
                  <span>
                    use the Website for benchmarking, competitive analysis, or
                    to build a competing product;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(h)</span>
                  <span>
                    remove or obscure any proprietary notices on the Website; or
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(i)</span>
                  <span>
                    impersonate any person, or submit false or frivolous
                    complaints regarding our processing of your Personal Data.
                  </span>
                </li>
              </ul>
            </section>

            <section id="ip" className="privacy-section">
              <h2>
                <span className="privacy-num">5.</span>INTELLECTUAL PROPERTY
              </h2>

              <p>
                5.1. All Content, text, graphics, trade marks, logos and other
                intellectual property appearing on the Website are and remain the
                exclusive property of Selenean or its licensors. Nothing in these
                Terms transfers ownership of any intellectual property to you,
                and no licence is granted beyond the limited right to view the
                Website under Clause 4 (Use of the Website).
              </p>

              <p>
                5.2. Descriptions of Selenean's semiconductor IP, circuit designs
                or other technology on the Website are provided for general
                information only. They do not themselves grant any licence to, or
                right to use, that technology; any such licence must be set out
                in a separate, duly signed licence agreement between you and
                Selenean.
              </p>

              <p>
                5.3. If you submit feedback, suggestions or other materials to us
                through the Website ("User Content"), you grant Selenean a
                worldwide, royalty-free, non-exclusive, perpetual and irrevocable
                licence to use, reproduce, modify and incorporate that User
                Content into our business operations. You represent that you hold
                all rights necessary to grant this licence.
              </p>
            </section>

            <section id="third-party" className="privacy-section">
              <h2>
                <span className="privacy-num">6.</span>THIRD-PARTY SERVICES AND
                LINKS
              </h2>

              <p>
                The Website may contain links to, or embed content from,
                third-party websites or services that are not owned or controlled
                by Selenean. We do not endorse and are not responsible for the
                content, accuracy, or practices of any third-party site. Your use
                of any third-party site is governed solely by that third party's
                own terms and privacy policy.
              </p>
            </section>

            <section id="no-offer" className="privacy-section">
              <h2>
                <span className="privacy-num">7.</span>NO OFFER OR SOLICITATION
              </h2>

              <p>
                7.1. The Website is provided for general information about
                Selenean and its business only. Nothing on the Website constitutes
                an offer to sell, licence or supply any product, technology or
                service, and no product, service, download or online payment
                facility is made available through the Website. Any commercial
                engagement with Selenean, including any licence to Selenean's
                semiconductor IP, comes into existence only upon execution of a
                separate written agreement, and is governed by the terms of that
                agreement and not by these Terms.
              </p>
            </section>

            <section id="warranties" className="privacy-section">
              <h2>
                <span className="privacy-num">8.</span>WARRANTIES AND DISCLAIMERS
              </h2>

              <p>
                8.1. The Website and its Content are provided "as is" and "as
                available" without warranties of any kind, whether express or
                implied. To the fullest extent permitted by applicable law,
                Selenean disclaims all implied warranties, including
                merchantability, fitness for a particular purpose,
                non-infringement, and accuracy of information.
              </p>

              <p>
                8.2. Without limiting the foregoing, Selenean does not warrant
                that the Website will be uninterrupted, timely, secure or
                error-free, or that any defects will be corrected within a
                specific timeframe. Product and technology descriptions on the
                Website are provided for general information and are subject to
                change without notice.
              </p>
            </section>

            <section id="liability" className="privacy-section">
              <h2>
                <span className="privacy-num">9.</span>LIMITATION OF LIABILITY
              </h2>

              <p>
                To the maximum extent permitted by applicable law, in no event
                shall Selenean, its directors, officers, employees, agents or
                affiliates be liable for any indirect, incidental, special,
                consequential or punitive damages, including loss of profits,
                data, business opportunities or goodwill, arising out of or in
                connection with your use of, or inability to use, the Website,
                even if advised of the possibility of such damages.
              </p>
            </section>

            <section id="indemnification" className="privacy-section">
              <h2>
                <span className="privacy-num">10.</span>INDEMNIFICATION
              </h2>

              <p>
                10.1. You agree to indemnify, defend and hold harmless Selenean,
                its parent, subsidiaries, affiliates, officers, directors,
                employees, agents and licensors from and against any claims,
                liabilities, damages, losses, costs or expenses (including
                reasonable attorneys' fees) arising out of or in connection with:
              </p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>your use of or access to the Website;</span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>your breach of these Terms or any applicable law;</span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    your violation of any third-party right, including
                    intellectual property, privacy or proprietary rights; or
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>any information you submit through the Website.</span>
                </li>
              </ul>

              <p>
                10.2. Selenean may, at its own expense, assume exclusive defence
                and control of any indemnifiable matter, in which case you will
                cooperate fully with any reasonable requests in asserting
                available defences.
              </p>
            </section>

            <section id="law" className="privacy-section">
              <h2>
                <span className="privacy-num">11.</span>GOVERNING LAW AND
                DISPUTE RESOLUTION
              </h2>

              <p>
                11.1. These Terms are governed by and construed in accordance with
                the laws of India, without regard to conflict-of-law principles.
              </p>

              <p>
                11.2. Any dispute arising out of or in connection with these Terms
                shall first be submitted to good-faith negotiation between the
                parties for a period of not less than thirty (30) days. If
                unresolved, the dispute shall be referred to and finally resolved
                by arbitration seated in Bangalore, India, conducted by a sole
                arbitrator appointed in accordance with the Arbitration and
                Conciliation Act, 1996, in the English language. Subject to this
                Clause, the courts at Bangalore, India shall have exclusive
                jurisdiction.
              </p>

              <p>
                11.3. Nothing in this Clause prevents either party from seeking
                injunctive or other equitable relief from a court of competent
                jurisdiction to protect intellectual property or trade secrets.
              </p>
            </section>

            <section id="grievance" className="privacy-section">
              <h2>
                <span className="privacy-num">12.</span>GRIEVANCE OFFICER
              </h2>

              <p>
                12.1. In accordance with applicable Indian law, Selenean has
                appointed the following Grievance Officer to address complaints
                regarding the Website:
              </p>

              <ul className="privacy-list privacy-officer">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Name:</strong> Sundeep Dasa
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Designation:</strong> Corporate Relations
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Email:</strong> sundeep@univisiontechnocon.com
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(d)</span>
                  <span>
                    <strong>Address:</strong> Nandi Infotech, KIADB Plot No. 8,
                    1st Cross, Sadaramangala Road, Mahadevapura Post Bengaluru -
                    560048
                  </span>
                </li>
              </ul>

              <p>
                12.2. The Grievance Officer will acknowledge complaints within a
                reasonable time and endeavour to resolve them within thirty (30)
                days, or such other period as prescribed by applicable law.
              </p>
            </section>

            <section id="general" className="privacy-section">
              <h2>
                <span className="privacy-num">13.</span>GENERAL
              </h2>

              <p>
                13.1. <strong>Force Majeure.</strong> Neither party is liable for
                delay or failure to perform caused by events beyond its
                reasonable control, including natural disasters, war, labour
                disputes, internet or utility failures, or governmental action.
              </p>

              <p>
                13.2. <strong>Notices.</strong> Notices under these Terms must be
                in writing and sent to the addresses in Clause 13 (Grievance
                Officer) or Clause 16 (Contact Us), or such other address as
                either party notifies in writing.
              </p>

              <p>
                13.3. <strong>Assignment.</strong> You may not assign or transfer
                these Terms without our prior written consent. Selenean may
                assign these Terms in connection with a merger, acquisition, or
                sale of assets, on notice to you.
              </p>

              <p>
                13.4. <strong>Severability.</strong> If any provision of these
                Terms is held invalid or unenforceable, the remaining provisions
                continue in full force, and the invalid provision will be
                replaced by a valid provision that most closely reflects the
                parties' original intent.
              </p>

              <p>
                13.5. <strong>Waiver.</strong> No failure or delay by either
                party in exercising any right under these Terms operates as a
                waiver of that right.
              </p>

              <p>
                13.6. <strong>Entire Agreement.</strong> These Terms, together
                with our Privacy Policy and Cookie Policy, constitute the entire
                agreement between you and Selenean regarding the Website and
                supersede all prior agreements on this subject.
              </p>
            </section>

            <section id="changes" className="privacy-section">
              <h2>
                <span className="privacy-num">14.</span>CHANGES TO THESE TERMS
              </h2>

              <p>
                14.1. Selenean may modify these Terms at any time. When we make
                material changes, we will update the "Last updated" date above
                and, where appropriate, provide additional notice by a prominent
                notice on the Website. Your continued use of the Website after
                revised Terms take effect constitutes acceptance of the changes.
                If you do not agree to the revised Terms, you must stop using the
                Website.
              </p>
            </section>

            <section id="contact" className="privacy-section">
              <h2>
                <span className="privacy-num">15.</span>CONTACT US
              </h2>

              <p>
                15.1. If you have questions, concerns or requests regarding these
                Terms or our data practices, please contact us, you may visit our
                Contact Page and submit your questions, concerns or requests, as
                the case may be.
              </p>
            </section>
          </article>
        </div>
      </section>
    </>
  );
}
